import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { SIDE_LENGTH_16, SIDE_LENGTH_8 } from '../constants.js';
import './GameModeToggle.css';

const disableClick = e => e.preventDefault();

const GameModeToggle = ({ currentGameId }) => (
    <div className="game-toggle">
        <Link
            to={`/boards/${SIDE_LENGTH_8}`}
            onClick={currentGameId === SIDE_LENGTH_8 && disableClick}
        >
            <div className={cn('button left', { 'selected': currentGameId === SIDE_LENGTH_8 })}>
                8x8
            </div>
        </Link>
        <Link
            to={`/boards/${SIDE_LENGTH_16}`}
            onClick={currentGameId === SIDE_LENGTH_16 && disableClick}
        >
            <div className={cn('button right', { 'selected': currentGameId === SIDE_LENGTH_16 })}>
                16x16
            </div>
        </Link>
    </div>
);

export default GameModeToggle;



// WEBPACK FOOTER //
// ./src/components/GameModeToggle.js